<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Consulta de Roles de Recaudador</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="consultar" class="btn-info btn--bigger">
                        <i class="fa fa-search"></i><span>Consultar</span>
                    </button>
                    <button @click="exportar" class="btn-success btn--bigger">
                        <i class="fa fa-file-excel-o"></i><span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Información de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2" :class="{
                        'select2--disabled': bodegas.length == 1
                        }">
                            <div class="select2-field">
                                <v-select @input="inputBodega" v-model="selectedBodega" :options="bodegas" label="descripcion" placeholder="Seleccione..."></v-select>
                                <label for="bodegas">Sucursal</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                placeholder="Seleccione..."
                                id="supervisor_id"
                                v-model="selectedRecaudadores"
                                :options="recaudadores"
                                multiple
                                @input="inputRecaudadores"
                                @search="searchRecaudadores"
                                label="nombre"
                                ></v-select>
                                <label for="supervisor_id">Recaudador</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo" v-model="form.tipo" id="tipo">
                                    <option value="T">Todos</option>
                                    <option value="P">Pagados</option>
                                    <option value="N">Pendientes</option>
                                </select>
                                <label for="tipo">Tipo</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Resultados de la Consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table
                            :buttons="buttons"
                            @anular="anular"
                            @imprimirExcel="imprimirExcel"
                            @imprimir="imprimir"
                            :buscarButton="false"
                            :filterStatus="false"
                            :deleteButton="false"
                            :createButton="false"
                            :editButton="false"
                            :params="form"
                            @pagar="pagar"
                            ref="roles"
                            :path="path"
                            :columns="[
                                {
                                display: 'Número de documento',
                                value: 'numero_documento',
                                },
                                {
                                display: 'Sucursal',
                                value: 'bodega.descripcion',
                                },
                                {
                                display: 'Desde',
                                value: 'desde',
                                },
                                {
                                display: 'Hasta',
                                value: 'hasta',
                                },
                                {
                                display: 'Inicial',
                                value: 'inicial_tarjetas'
                                },
                                {
                                display: 'Activas',
                                value: 'tarjetas_activas'
                                },
                                {
                                display: 'Nuevas',
                                value: 'tarjetas_nuevas'
                                },
                                {
                                display: 'Supervision',
                                value: 'valor_supervision',
                                numeric: true,
                                },
                                {
                                display: 'Supervisadas',
                                value: 'tarjetas_supervisadas'
                                },
                                {
                                display: 'Dev. Completas',
                                value: 'devoluciones_completas'
                                },
                                {
                                display: 'Valor de Pago',
                                value: 'valor_pago',
                                numeric: true,
                                },
                                {
                                display: 'Movimientos',
                                value: 'total_movimientos',
                                numeric: true,
                                },
                                {
                                display: 'Liq. Recibir',
                                value: 'liquido_recibir',
                                numeric: true,
                                },
                            ]"
                            ></k-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                tipo: 'T',
                recaudadores_id:  [],
                bodega_id: '',
                tipo_consulta: 'N'
            },
            selectedRecaudadores: [],
            selectedBodega: null,
            path: url + '/consulta-roles-recaudador',
            recaudadores: [],
            buttons: [{
                event: 'imprimirExcel',
                icon: 'fa-file-excel-o',
                class: 'btn-success btn--text'
            },
            {
                event: 'imprimir',
                icon: 'fa-file-pdf-o',
                class: 'btn-danger btn--text'
            }]
        };
    },
    props: {
        pagar_rol_rec: {
            type: Boolean,
            required: false,
            default: false
        },
        bodegas: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        anular_rol_recaudacion: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        imprimir: function (row) {
            window.open(url + '/rol-recaudador/' + row.id + '/pdf', '_blank');
        },
        imprimirExcel: function (row) {
            window.open(url + '/rol-recaudador/' + row.id + '/excel', '_blank');
        },
        exportar: function () {
            this.form.tipo_consulta = 'E';
            this.$refs.roles.exportar();
        },
        consultar: function () {
            this.form.tipo_consulta = 'N';
            this.$refs.roles.loadRows();
        },
        searchRecaudadores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.recaudadores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open(
                "GET",
                url + "/search/usuarios?bodega_id=" + this.form.bodega_id + "&tipo=R&search=" + search,
                true
            );
            xmlhttp.send();
        },
        pagar: function (row) {
            swal({
                title: "¿Desea pagar el rol de recaudación seleccionado?",
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Pagar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    axios.post(url + '/rol-recaudador/' + row.id + '/pagar').then(() => {
                        swal('El rol fue pagado exitósamente.', 'Realizado', 'success');
                        this.consultar();
                    }).catch(({response}) => {
                        if (response.status == 409) {
                            swal('El rol de pago ya fue pagado con anterioridad.', 'Aviso', 'warning');
                        }
                        else
                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });
        },
        inputRecaudadores: function () {
            this.form.recaudadores_id.splice(0, this.form.recaudadores_id.length);
            for (let i = 0; i < this.selectedRecaudadores.length; i++) {
                this.form.recaudadores_id.push(this.selectedRecaudadores[i].id);
            }
        },
        inputBodega: function () {
            if (this.selectedBodega != null)
                this.form.bodega_id = this.selectedBodega.id;
            else  
                this.form.bodega_id = '';
        },
        anular: function (row) {
            swal({
                title: "¿Desea anular el rol de recaudación?",
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Anular",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    axios.post(url + '/rol-recaudador/' + row.id, {
                        _method: 'DELETE'
                    }).then(() => {
                        swal('El rol fue anulado exitósamente.', 'Realizado', 'success');
                        this.consultar();
                    }).catch(({response}) => {
                        if (response.status == 409) {
                            swal('No se puede anular un rol de recaudación pagado.', 'Error', 'error');
                        }
                        else
                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });
        },
    },
    mounted: function () {
        if (this.anular_rol_recaudacion) {
            this.buttons.push({
                event: 'anular',
                icon: 'fa-trash',
                class: 'btn-warning btn--text'
            });
        }
        if (this.pagar_rol_rec) {
            this.buttons.push({
                event: 'pagar',
                icon: 'fa-money',
                class: 'btn-success btn--text'
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/ConsultaRolesRecaudador.vue